export default __webpack_public_path__ + "static/media/gallery-wip-emitter_08.d077cf20.jpg";